/**
 * Enum for how 3D tiles encodes the component type. We will convert this to our own NumType.
 */
export var ComponentType;
(function (ComponentType) {
    ComponentType["BYTE"] = "BYTE";
    ComponentType["UNSIGNED_BYTE"] = "UNSIGNED_BYTE";
    ComponentType["SHORT"] = "SHORT";
    ComponentType["UNSIGNED_SHORT"] = "UNSIGNED_SHORT";
    ComponentType["INT"] = "INT";
    ComponentType["UNSIGNED_INT"] = "UNSIGNED_INT";
    ComponentType["FLOAT"] = "FLOAT";
    ComponentType["DOUBLE"] = "DOUBLE";
})(ComponentType || (ComponentType = {}));
/**
 * Conversion from ComponentType into NumType
 * @param t
 */
export function componentTypeToNumType(t) {
    switch (t) {
        case ComponentType.BYTE:
            return 4 /* NumType.I8 */;
        case ComponentType.UNSIGNED_BYTE:
            return 0 /* NumType.U8 */;
        case ComponentType.SHORT:
            return 5 /* NumType.I16 */;
        case ComponentType.UNSIGNED_SHORT:
            return 1 /* NumType.U16 */;
        case ComponentType.INT:
            return 6 /* NumType.I32 */;
        case ComponentType.UNSIGNED_INT:
            return 2 /* NumType.U32 */;
        case ComponentType.FLOAT:
            return 8 /* NumType.F32 */;
        case ComponentType.DOUBLE:
            return 9 /* NumType.F64 */;
        default:
            throw new Error(`Unknown component type '${t}'`);
    }
}
/**
 * Enum for how 3D tiles encodes the number of components. We will convert this into a number.
 */
export var VectorType;
(function (VectorType) {
    VectorType["SCALAR"] = "SCALAR";
    VectorType["VEC2"] = "VEC2";
    VectorType["VEC3"] = "VEC3";
    VectorType["VEC4"] = "VEC4";
})(VectorType || (VectorType = {}));
/**
 * Conversion from VectorType into the number of components the value implies
 * @param v
 */
export function numComponentsForVectorType(v) {
    switch (v) {
        case VectorType.SCALAR:
            return 1;
        case VectorType.VEC2:
            return 2;
        case VectorType.VEC3:
            return 3;
        case VectorType.VEC4:
            return 4;
        default:
            throw new Error(`Unknown vector type ${v}`);
    }
}
